<section>
  @if (selected) {
    <ng-container [ngTemplateOutlet]="selected.content" />
  }

  <footer class="stepper-navigation-bar">
    @for (step of steps; track step; let i = $index) {
      <button class="stepper-step" aria-label="slider bullet" [class.active-step]="selectedIndex === i"
        (click)="selectStepByIndex(i)">
      </button>
    }
  </footer>
</section>
